import React, { useState } from 'react';
import './RequestConversationBar.css';

function RequestConversationBar({
  apiEndpoint = '/send-contact-form-landing',
  servicesList = [
    "Sport medicine",
    "Audiology",
    "Dna analysis",
    "Global Medical Consulting",
    "Medical aesthetics",
    "Aging & wellness",
    "IV therapy",
    "Naturopathic medicine",
    "Orthopaedic",
  ],
  timeSlots = [
    '9:30 a.m.',
    '10:00 a.m.',
    '10:30 a.m.',
    '11:00 a.m.',
    '11:30 a.m.',
    '12:00 p.m.',
    '12:30 p.m.',
    '1:00 p.m.',
    '1:30 p.m.',
    '2:00 p.m.',
    '2:30 p.m.',
    '3:00 p.m.',
    '3:30 p.m.',
    '4:00 p.m.',
    '4:30 p.m.'
]
}) {
  const [formData, setFormData] = useState({
    patientName: '',
    email: '',
    phoneNo: '',
    service: servicesList[0] || '',
    date: '',
    time: timeSlots[0] || ''
  });

  const [status, setStatus] = useState({ loading: false, success: false, error: null });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ loading: true, success: false, error: null });

    try {
      const response = await fetch(apiEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (!response.ok) {
        throw new Error('Failed to send request. Please try again.');
      }

      setStatus({ loading: false, success: true, error: null });
      setFormData({
        patientName: '',
        email: '',
        phoneNo: '',
        service: servicesList[0] || '',
        date: '',
        time: timeSlots[0] || ''
      });
    } catch (err) {
      setStatus({ loading: false, success: false, error: err.message });
    }
  };

  return (
    <div className="ttc-request-bar-wrapper container">
      <div className="ttc-request-card">
        {/* Header Title Row */}
        <div className="d-flex flex-wrap justify-content-between align-items-baseline mb-3">
          <div>
            <h3 className="ttc-request-title mb-1">Request a conversation</h3>
            <p className="ttc-request-subtitle mb-0">
              A preferred window — confirmed only when the clinic calls you back.
            </p>
          </div>
          <div className="ttc-time-zone text-uppercase">
            • TORONTO TIME
          </div>
        </div>

        {/* Success / Error Feedback */}
        {status.success && (
          <div className="alert alert-success py-2 px-3 mb-3 text-center" style={{ fontSize: '0.85rem' }}>
            Thank you! Your request has been sent. Our clinic will contact you shortly.
          </div>
        )}
        {status.error && (
          <div className="alert alert-danger py-2 px-3 mb-3 text-center" style={{ fontSize: '0.85rem' }}>
            {status.error}
          </div>
        )}

        {/* Form Inputs Grid */}
        <form onSubmit={handleSubmit}>
          <div className="row g-2 align-items-end">
            {/* Patient Name */}
            <div className="col-12 col-sm-6 col-lg-2">
              <label className="ttc-form-label">PATIENT NAME</label>
              <input
                type="text"
                name="patientName"
                className="form-control ttc-form-input"
                placeholder="Your name"
                value={formData.patientName}
                onChange={handleChange}
                required
              />
            </div>

            {/* Email */}
            <div className="col-12 col-sm-6 col-lg-2">
              <label className="ttc-form-label">EMAIL</label>
              <input
                type="email"
                name="email"
                className="form-control ttc-form-input"
                placeholder="Your Email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            {/* Phone No */}
            <div className="col-12 col-sm-6 col-lg-2">
              <label className="ttc-form-label">PHONE NO</label>
              <input
                type="tel"
                name="phoneNo"
                className="form-control ttc-form-input"
                placeholder="Phone No"
                value={formData.phoneNo}
                onChange={handleChange}
                required
              />
            </div>

            {/* Services Select */}
            <div className="col-12 col-sm-6 col-lg-2">
              <label className="ttc-form-label">SERVICES</label>
              <select
                name="service"
                className="form-select ttc-form-input"
                value={formData.service}
                onChange={handleChange}
              >
                {servicesList.map((srv, idx) => (
                  <option key={idx} value={srv}>
                    {srv}
                  </option>
                ))}
              </select>
            </div>

            {/* Date */}
            <div className="col-12 col-sm-6 col-lg-2">
              <label className="ttc-form-label">DATE</label>
              <input
                type="date"
                name="date"
                className="form-control ttc-form-input"
                value={formData.date}
                onChange={handleChange}
                min={new Date().toISOString().split("T")[0]}
                required
              />
            </div>

            {/* Time Select */}
            <div className="col-12 col-sm-6 col-lg-1">
              <label className="ttc-form-label">TIME</label>
              <select
                name="time"
                className="form-select ttc-form-input"
                value={formData.time}
                onChange={handleChange}
              >
                {timeSlots.map((slot, idx) => (
                  <option key={idx} value={slot}>
                    {slot}
                  </option>
                ))}
              </select>
            </div>

            {/* Submit Button */}
            <div className="col-12 col-lg-1">
              <button
                type="submit"
                disabled={status.loading}
                className="btn ttc-request-btn w-100"
              >
                {status.loading ? '...' : 'Request'}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default RequestConversationBar;